import React, { useContext } from "react";
import { ClientContext } from "../../context/Client/ClientContext";
import ClientCard from "./ClientCard";

const ClientList = () => {
  const { clientList, incrementPage, enableShowMore, isSearchByName } =
    useContext(ClientContext);

  const clientListEmpty = !clientList || clientList.length < 1;

  return (
    <div className="gog-client-list">
      {clientListEmpty ? (
        <div className="gog-client-list-empty">
          <strong>No merchants yet</strong>
          <span>Search results will appear here.</span>
        </div>
      ) : (
        <div className="gog-client-list-scroll">
          {clientList.map((client) => (
            <ClientCard client={client} key={client.id} />
          ))}
        </div>
      )}

      {enableShowMore && !isSearchByName && !clientListEmpty && (
        <div className="gog-client-list-actions">
          <button
            type="button"
            onClick={incrementPage}
            className="gog-secondary-btn"
          >
            Show More
          </button>
        </div>
      )}
    </div>
  );
};

export default ClientList;